import { getSessionId } from "../../../utils/tokenHandlers";
import axios from "axios";
import UidEmailRoleMatch from "../../constants/uidEmailRoleMatch";

export const fetchCommunicationAddress = async (customerId: number) => {
  const sessionId = getSessionId();
  const filter = JSON.stringify([
    ["customer_id", "in", [customerId]],
    ["type", "=", "Communication"],
  ]);
  const UidEmailRole = UidEmailRoleMatch();

  try {
    const response = await axios.post(
      `${process.env.REACT_APP_BASE_URL}api/read/many/tradexwbench.customer_address/`,
      {
        params: {
          ...UidEmailRole,
          filter,
          query:
            "{id,customer_id,type,line_1,line_2,city,district,state,pincode,country_id{name},phone_country_code,phone,email,billing_gstn,business_billing_preference_email,business_communication_preference_email, business_billing_gstn,api_com_city_flag,api_com_district_flag,api_com_state_flag,api_com_country_flag, api_com_line_1_flag, api_com_line_2_flag, api_com_pincode_flag}",
        },
      },
      {
        headers: {
          Authorization: `Bearer ${sessionId}`,
        },
      }
    );
    return response;
  } catch (err) {
    return err;
  }
};
